var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"academy-rules"},[_c('section',{staticClass:"section-top"},[(_vm.ready)?_c('div'):_c('div',{staticClass:"content-empty"},[_c('PageComingSoon',{attrs:{"titleText":' ',"descriptionText":String(_vm.readyMsg)}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }